<template>
  <div>
    <div class="container" style=" min-height:685px;">
      <v-app style="height: 10px;">
        <v-progress-linear v-show="loading" indeterminate></v-progress-linear>
      </v-app>

      <div class="print_area" id="screen_area" v-if="info">
        <div class="row">
          <div class="col-xs-12" style="margin-top: 10px;" v-if="dataInfo.mobile">
            <v-btn color="info"  @click="back">返回</v-btn>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12">
            <div v-if="info.status === '0'" class="alert alert-success nomal_text" style="font-size: 30px;margin-top: 20px;display: block;width: 100%;text-align: center ">
              <span>交易結果訊息 ：</span>
              <span>付款成功 (Success)</span>
            </div>
            <div v-else class="alert alert-danger nomal_text" style="font-size: 30px;margin-top: 20px;display: block;width: 100%;text-align: center ">
              <span>交易結果訊息 ：</span>
              <span>付款失敗 ({{info.errDesc}})</span>
            </div>
          </div>
          <div class="col-md-12">
            <div class="nomal_title " style="margin-top: 20px;display: block ">
              付款資訊
            </div>
            <div class="oge_line" style="width: 100%; margin-bottom: 10px"></div>
            <div class="pay_data" style="margin-bottom: 10px">
              <table cellpadding="0" cellspacing="0" class="paycard2 " width="100%" style="float: left">
                <tbody><tr>
                  <td class="order_td_name">
                    信用卡授權碼
                  </td>
                  <td class="order_td_content">
                    {{info.authCode}}
                  </td>
                </tr>
                <tr>
                  <td class="order_td_name">訂單金額</td>
                  <td class="order_td_content">NT${{info.authAmt}}</td>
                </tr>
                <tr v-if="info.PayType > 0">
                  <td class="order_td_name">分期</td>
                  <td class="order_td_content">期數:{{info.PeriodNum}} 首期金額:NT${{info.DownPayments}} 每期金額:NT${{info.InstallmentPayments}}</td>
                </tr>
                <tr v-else>
                  <td class="order_td_name">實際付款金額</td>
                  <td class="order_td_content">NT${{info.authAmt}}</td>
                </tr>
                <tr v-if="getAgentPrice > 0">
                  <td class="order_td_name">撥款金額</td>
                  <td class="order_td_content">${{getAgentPrice}}</td>
                </tr>
                <tr v-if="getAgentPrice > 0">
                  <td class="order_td_name">撥款日期</td>
                  <td class="order_td_content">{{getGrantDate}}</td>
                </tr>
                <tr>
                  <td class="order_td_name">交易結果訊息</td>
                  <td class="order_td_content">
                                        <span v-if="info.status === '0'">
                                               付款成功 (Success)
                                        </span>
                    <span v-else>付款失敗 ({{info.errDesc}})</span>
                  </td>
                </tr>
                <tr>
                  <td class="order_td_name">信用卡授權結果</td>
                  <td class="order_td_content">
                                        <span v-if="info.status === '0'">
                                               授權成功 ({{info.authCode}})
                                        </span>
                    <span v-else>授權失敗 ({{info.message}})</span>
                  </td>
                </tr>
                <tr>
                  <td class="order_td_name">持卡人姓名</td>
                  <td class="order_td_content">{{info.customerName}}</td>
                </tr>
                <tr>
                  <td class="order_td_name">信用卡卡號</td>
                  <td class="order_td_content">{{info.pan}}</td>
                </tr>
                <tr>
                  <td class="order_td_name">交易時間</td>
                  <td class="order_td_content">{{info.createdDate}}</td>
                </tr>
                </tbody></table>
            </div>



          </div>
          <div class="col-xs-12 col-md-12">
            <div class="nomal_title " style="margin-top: 20px;display:inline-block ">商店資訊
              <span class=" glyphicon glyphicon-plus switch_shop" id="open_order_data"></span>
              <span class=" glyphicon glyphicon-minus switch_shop" id="close_order_data"></span>
            </div>
            <div class="oge_line" style="width: 100%;margin-bottom: 10px"></div>

            <div class=" order_data">  <!--小螢幕則縮小-->
              <table cellpadding="0" cellspacing="0" class="paycard2 " width="100%" style="float: left;　">
                <tbody><tr>
                  <td class="order_td_name">商店名稱</td>
                  <td class="order_td_content">嘉好企業有限公司({{info.merID}})</td>
                </tr>
                <tr>
                  <td class="order_td_name">商店訂單編號</td>
                  <td class="order_td_content">{{info.orderId}}</td>
                </tr>
<!--                <tr>-->
<!--                  <td class="order_td_name">智付通交易序號</td>-->
<!--                  <td class="order_td_content">{{info.TradeNo}}</td>-->
<!--                </tr>-->
                </tbody></table>
              <div class=" clearfix"></div>
            </div>


          </div>

          <!--教學資訊-->
          <div class="col-xs-12">
            <div class="nomal_text" style=" width: 100%;margin-top: 10px">
              <ul class="disc" style="margin-left: 25px;line-height: 35px;font-size: 15px">
                <li>您的款項已透過智付通第三方支付平台完成付款。</li>
                <li>您的信用卡帳單中交易項目將顯示「智付通 - 嘉好企業有限公司」，交易項目顯示名稱視信用卡帳單上可接受長度為主。</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { customFormatDate } from '../utils/tool';
import {mapActions, mapGetters} from 'vuex';
export default {
  name:'PaymentResultView',
  data() {
    return {
      loading: false,
      info: null,
    }
  },
  created(){
    if(this.dataInfo.isAdmin === 'true'){
      this.fetchAgentList();
    }

    this.loadPaymentInfo();
  },
  watch:{
    $route: function (from , to) {
      // console.log(`$route update ${from} ${to}`);
      this.loading = true;
      setTimeout(()=>{
        this.loading = false;
      }, 1500);
    }
  },
  computed: {
    ...mapGetters(['getUserInfo', 'getAgentList']),
    dataInfo() {
      return this.$route.query;
    },
    getGrantDate() {
      const payDate = this.dataInfo.PayTime;
      const date = new Date(payDate);
      date.setDate(date.getDate() + 8);
      return customFormatDate(date, 'YYYY-MM-DD');
    },
    getAgentPrice(){
      const agent = this.getAgentList.find(member=>member.agentId === this.dataInfo.agentId);
      console.log(`agent == ${JSON.stringify(agent)}`);
      //console.log(`this.dataInfo == ${JSON.stringify(this.dataInfo)}`);
      if(agent){
        let amount = 0;
        const inst = parseInt(this.dataInfo.Inst);
        if (inst > 0){
          if (inst === 3){
            if (agent.fees3 && parseFloat(agent.fees3) > 0){
              amount =  Math.round((parseFloat(this.dataInfo.Amt) * parseFloat(agent.fees3)) / 100);
            } else {
              amount = Math.round((parseFloat(this.dataInfo.Amt) * parseFloat(agent.fees)) / 100);
            }
          } else if (inst === 6){
            if (agent.fees6 && parseFloat(agent.fees6) > 0){
              amount =  Math.round((parseFloat(this.dataInfo.Amt) * parseFloat(agent.fees6)) / 100);
            } else {
              amount = Math.round((parseFloat(this.dataInfo.Amt) * parseFloat(agent.fees)) / 100);
            }
          } else if (inst === 12){ //10%
            if(agent.agentId === '23kmvC1FxrccTY4Qjz8nekR5BMc2'){
              amount =  Math.round((parseFloat(this.dataInfo.Amt) * 9) / 100);
              //console.log(`12期 9% ${amount}`);
            }else{
              if (agent.fees12 && parseFloat(agent.fees12) > 0){
                amount =  Math.round((parseFloat(this.dataInfo.Amt) * parseFloat(agent.fees12)) / 100);
              } else {
                amount =  Math.round((parseFloat(this.dataInfo.Amt) * 10) / 100);
                //console.log(`12期 10% ${amount}`);
              }
            }
          }else if (inst === 18){ //13%
            if (agent.fees18 && parseFloat(agent.fees18) > 0){
              amount =  Math.round((parseFloat(this.dataInfo.Amt) * parseFloat(agent.fees18)) / 100);
            } else {
              amount =  Math.round((parseFloat(this.dataInfo.Amt) * 13) / 100);
            }
          }else if (inst === 24){ //13%
            if (agent.fees24 && parseFloat(agent.fees24) > 0){
              amount =  Math.round((parseFloat(this.dataInfo.Amt) * parseFloat(agent.fees24)) / 100);
            }else{
              amount =  Math.round((parseFloat(this.dataInfo.Amt) * 17) / 100);
            }
          }else if (inst === 30){ //13%
            if (agent.fees30 && parseFloat(agent.fees30) > 0){
              amount =  Math.round((parseFloat(this.dataInfo.Amt) * parseFloat(agent.fees30)) / 100);
            } else {
              amount =  Math.round((parseFloat(this.dataInfo.Amt) * 19.8) / 100);
            }
          }else{
            amount = Math.round((parseFloat(this.dataInfo.Amt) * parseFloat(agent.fees)) / 100);
          }
          const result = parseFloat(this.dataInfo.Amt) - amount;
          console.log(`D ${amount}`);
          return result;
        }else{
          if (agent.fees) {
            const amount = Math.round((parseFloat(this.dataInfo.Amt) * parseFloat(agent.fees)) / 100);
            console.log(`A ${parseFloat(this.dataInfo.Amt)} ${parseFloat(agent.fees)} / 100 =  ${amount}`);
            const result = parseFloat(this.dataInfo.Amt) - amount;
            return result;
          } else {
            let amount =  Math.round((parseFloat(this.dataInfo.Amt) * 6) / 100);
            console.log(`B ${amount}`);
            const result = parseFloat(this.dataInfo.Amt) - amount;
            return result;
          }
        }
      } else {
        let amount = parseFloat(this.dataInfo.Amt) - Math.round((parseFloat(this.dataInfo.Amt) * 6) / 100);
        console.log(`C ${amount}`);
        return amount;
      }
    }
  },
  methods:{
    ...mapActions(['fetchAgentList', 'searchPaymentInfo']),
    async loadPaymentInfo(){

      if (this.dataInfo.orderId && this.dataInfo.orderId !== ''){
        this.loading = true;
        const res = await this.searchPaymentInfo({ orderId: this.dataInfo.orderId});
        const result = res.data;
        this.info = result.data;
        this.loading = false;
        console.log(`loadPaymentInfo == ${JSON.stringify(result)}`);
      }
    },
    back(){
      this.$router.back();
    }
  }
}
</script>

<style lang="css" scoped>
body, div, ul, ol, li, h1, h2, h3, h4, h5, h6, form, input, button,textarea, p, blockquote, th, td {
  margin: 0;
  padding: 0;
  margin-left: 0px;
}
img {border: 0;}
:focus {outline: 0;}
h1, h2, h3, h4, h5, h6 {font-size: 100%;font-weight: normal;
}

span.test {
  color: red;
}

body{
  font-family: Arila, Microsoft JhengHei,sans-serif, Helvetica;
}

.container {
  min-width: 320px;
  margin: 0 auto;
}

div{
  font-family:arial,微軟正黑體,Microsoft JhengHei;
}
.nomal_text{
  font-family:Arila,Microsoft JhengHei;
  font-size: 16px;
  color:  #585858;
}


.nomal_title{
  font-family:arial,微軟正黑體,Microsoft JhengHei;
  font-size: 20px;
  color: #0B75A0;
  font-weight: normal;
  display: block;

  line-height: 20px;
  height: 20px;
}

.mpg-footer p:last-child {
  margin-bottom: 0;
}

.registr_left h2 a{
  font-size: 24px;
  color: #0B75A0;
  font-family: arial,微軟正黑體,Microsoft JhengHei;
  font-weight: normal;
  margin-bottom: 30px;
  margin-left: 150px;
  display: block;
  text-decoration: none;
}

.registr_left .tit_p {
  font-family: arial,微軟正黑體,Microsoft JhengHei;
  font-size: 20px;
  color: #0B75A0;
  margin-left:170px;
  margin-top:20px;
}
.registr_left .info_p {
  font-family: arial,微軟正黑體,Microsoft JhengHei;
  font-size: 17px;
  margin-top: 5px;
  margin-left:170px;
}
.registr_left .img_link {
  height: 150px;
  width: 160px;
  margin-top: -120px;
  z-index: 1000;
  text-indent: -9999;
  display: block;
}
.registr_left .img_link a {
  text-indent: -9999px;
  display: block;
  height: 150px;
  width: 150px;
}


.registr_right h2 a{
  font-size: 24px;
  color: #0B75A0;
  font-family: arial,微軟正黑體,Microsoft JhengHei;
  font-weight: normal;
  margin-left: 150px;
  display: block;
  text-decoration: none;

  font-size: 24px;
  color: #0B75A0;
  font-family: arial,微軟正黑體,Microsoft JhengHei;
  font-weight: normal;
  margin-left: 150px;
  display: block;
  text-decoration: none;
}
.registr_right .tit_p {
  font-family: arial,微軟正黑體,Microsoft JhengHei;
  font-size: 20px;
  color: #0B75A0;
  margin-left:170px;
  margin-top: 30px;
}
.registr_right .info_o {
  font-family: arial,微軟正黑體,Microsoft JhengHei;
  font-size: 17px;
  margin-top: 5px;
  margin-left:170px;
}
.registr_right .img_link {
  height: 150px;
  width: 160px;
  margin-top: -120px;
  z-index: 1000;
  text-indent: -9999;
  display: block;
}
.registr_right .img_link a {
  text-indent: -9999px;
  display: block;
  height: 150px;
  width: 150px;
}





ul.disc {
  list-style-type:disc;
}
.nav ul li{
  list-style: none;
}

.bank_table thead {
  border: 1px solid #999;
  line-height: 30px;
  font-weight: normal;
  background-color: #F5F5F5;
  border-top-width: 2px;
  border-right-width: 1px;
  border-bottom-width: 1px;
  border-left-width: 1px;
  border-top-style: solid;
  border-right-style: solid;
  border-bottom-style: solid;
  border-left-style: solid;
  border-top-color: #999;
  border-right-color: #999;
  border-bottom-color: #999;
  border-left-color: #999;
  font-size: 14px;


}
.bank_table thead tr th{
  text-align: center;
}
.bank_table tbody tr:hover{
  background-color: rgba(253, 253, 131, 0.2);
}
.no_hover tbody tr:hover{
  background-color: white;
}
.ifbox a{
  font-family:arial,微軟正黑體,Microsoft JhengHei;
  font-size: 14px;
  color: #930;
  display: inline-block;
  padding: 4px;
  border: 1px solid #cccccc;
  border-radius: 3px;
  background-color: #F2F2F2;
  margin-left: 6px;
  text-decoration: none;
}



.cbo .service_f20{
  font-family: arial,微軟正黑體,Microsoft JhengHei;
  font-size: 14px;
  line-height: 30px;
  color: #666666;
  text-align: justify;
}

.cbo .service_box{
  font-family:arial,微軟正黑體,Microsoft JhengHei;
  font-size: 14px;
  line-height: 30px;
  color: #666666;
  text-align: justify;
}
.service_box h3 {
  font-family: arial,微軟正黑體,Microsoft JhengHei;
  font-size: 17px;
  line-height: 35px;
  color: #666666;
  display: block;
  border-bottom-width: 1px;
  border-bottom-style: dashed;
  border-bottom-color: #999;
  width: 100%;
  height: 35px;
  margin-bottom: 5px;
  font-weight: normal;
}

.jastips span{
  display:none;
}
.jastips:hover span{
  display:block;
  position:absolute;
  float:left;
  white-space:nowrap;
  top:-10px;
  left:20px;
  background: rgba(10, 10, 10, 0.6);
  border:1px solid #000;
  color:#fff;
  padding:1px 5px;
  margin:0;
  z-index:9;
}


.oge_line {
  border-bottom-width: 1px;
  border-bottom-style: solid;
  border-bottom-color: #0B75A0;
  height: 15px;
  margin-bottom: 15px;
  display: block;
}

.paycard2 {
  border: 1px solid #F0F0F0;
  padding: 5px;
}
.paycard2 tr th {
  border: 1px solid #EAEAEA;
  padding: 3px;
  height: 35px;
  line-height: 35px;
}
.paycard2 tr td {
  border: 1px solid #EAEAEA;
  padding-top: 3px;
  padding-right: 3px;
  padding-bottom: 3px;
  padding-left: 10px;
  height: 35px;
  line-height: 35px;

}


.login_1 ul li{ float:left; list-style:none;}
.order_td_name{
  font-weight:bold;
}
.switch_shop{
  cursor:pointer;font-size: 18px;font-weight: bold;
}


@media(min-width:1025px)
{
  #mbacc{
    text-align:right;
  }
  .footer_text{font-size: 14px; line-height: 20px;}
  .foot_text{font-size: 14px; line-height: 20px;}
  .order_td_name{width:auto;white-space: nowrap; }
  .order_td_content{ width:85%;}
  .footer_text{font-size:16px; line-height: 26px;  }
  .mail_text{display:inline-block;width:12%; }
  .mail_addr{display:inline-block; width:40%; }
  .card_tit{display:inline-block; width:8%; }
  .card_text{display:inline-block;width:15%;}
  .card_cvc{display:inline-block; width:10%}
  #statement{ display: block;  }
  #use_modal_term{display: none; }
  #open_order_data{display: none; }
  .order_data{margin-bottom: 20px;display:block;}
  .logo {width: 330px; margin-top:-5px;}
  #close_order_data{
    display:none
  }
}

@media(min-width:640px) and (max-width:1024px)
{
  #mbacc{
    text-align:left;
  }
  .order_td_name{ width:auto;white-space: nowrap; }
  .order_td_content{width:80%; }
  .footer_text{ font-size:16px;line-height: 26px; }
  .mail_text{ display:inline-block;width:18%; }
  .mail_addr{ display:inline-block; width:40%; }
  .card_tit{ display:inline-block; width:11%;   }
  .card_text{ display:inline-block;width:15%; }
  .card_cvc{ display:inline-block;width:10%}
  #statement{ display: none; }
  #use_modal_term{display: block;  }
  #chosse_inst{width:30%; }
  .paycard2 tr td {line-height: 30px; }
  #open_order_data{ display:inline-block; }
  .order_data{margin-bottom: 20px;display:none;}
  #close_order_data{
    display:none
  }
}

@media(max-width: 640px)
{
  #mbacc{
    text-align:left;
  }
  .footer_text{font-size: 12px; line-height: 20px;}
  .foot_text{font-size: 12px; line-height: 20px;}
  .order_td_name{ width:45%;white-space: nowrap;  }
  .order_td_content{width:55%; word-wrap: break-word;  word-break: break-all;  }
  .mail_text{  display:block;width:100%;    }
  .mail_addr{ display:block;width:100%;      }
  .card_tit{ display:block;width:100%;  }
  .card_text{display:block;width:60%;   }
  .card_cvc{ display:inline-block; width:25%  }
  #statement{display: none;  }
  #use_modal_term{display: block;  }
  .paycard2 tr td {  line-height: 30px;  }
  #open_order_data{  display:inline-block;  }
  .order_data{ margin-bottom: 20px;display:none; }
  #close_order_data{
    display:none
  }
  .logo {width: 250px; margin-top:0px;}
  .in_header_t {width: 100%; height: 45px; margin: 0 auto; }
}
.paycard2 tr td{
  padding-right: 9px;
}

.alert {
  padding: 15px;
  margin-bottom: 20px;
  border: 1px solid transparent;
  border-radius: 4px;
}

.alert-success {
  color: #3c763d;
  background-color: #dff0d8;
  border-color: #d6e9c6;
}

.alert-danger {
  background-color: #f2dede;
  border-color: #ebcccc;
  color: #a94442;
}

.footer {
  position: fixed;
  /*bottom: 0;*/
  /*left: 0;*/
  text-align: center;
  width: 100%;
  /*margin-left: 0;*/
  /*margin-right: 0;*/
  /*z-index: 3;*/
  /*background-color: #e1e1e1;*/
}

.btnBox {
  display: block;
  padding: 0 15px 0 15px;
  height: 100px;
  width: 100%;
}

.footer .white2Btn {
  width: 100%;
  margin-top: 5px
}

</style>



// WEBPACK FOOTER //
// src/pages/web/PaymentResultView.vue